import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../components/common/general/CustomText/CustomText";
import { GetCourseStudentInsightsQuery } from "../../../../graphql/generated/graphql";
import { colors, radii, spacing } from "../../../../styles/design-system";
import ModuleInsightsCard from "../../AdminCourseModulesContainer/components/ModuleInsightsCard";

interface RosterInsightByModuleContainerProps {
  studentInsights: NonNullable<GetCourseStudentInsightsQuery["getCourseStudentInsights"]["data"]> | null;
}

const RosterInsightByModuleContainer = ({ studentInsights }: RosterInsightByModuleContainerProps) => {
  const payload = studentInsights?.moduleInsights;
  const moduleCards = payload?.moduleCards ?? [];

  if (!payload) {
    return (
      <View style={styles.errorContainer}>
        <CustomText text="Failed to load module insights" size="m" weight="medium" useTranslationText={false} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {moduleCards.length === 0 ? (
        <View style={styles.emptyState}>
          <CustomText
            text="No module insights are available for this student yet."
            size="m"
            weight="medium"
            useTranslationText={false}
          />
          <CustomText
            text="Once the student starts working through the course, module-level progress will show up here."
            size="s"
            useTranslationText={false}
            style={styles.mutedText}
          />
        </View>
      ) : (
        <View style={styles.modulesSection}>
          {moduleCards.map((moduleCard, index) => (
            <ModuleInsightsCard
              key={moduleCard.moduleId}
              moduleCard={moduleCard}
              activities={moduleCard.activities}
              moduleIndex={index + 1}
              defaultExpanded={index === 0}
              isByModule={true}
            />
          ))}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.lg,
    gap: spacing.lg,
  },
  errorContainer: {
    minHeight: 180,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
    borderRadius: radii.lg,
    borderWidth: 1,
    borderColor: colors.grey[200],
    padding: spacing.lg,
  },

  mutedText: {
    color: colors.grey[500],
  },

  emptyState: {
    minHeight: 180,
    justifyContent: "center",
    alignItems: "center",
    gap: spacing.sm,
    backgroundColor: colors.white,
    borderRadius: radii.xl,
    borderWidth: 1,
    borderColor: colors.grey[200],
    padding: spacing.lg,
  },
  modulesSection: {
    gap: spacing.md,
  },
});

export default RosterInsightByModuleContainer;
